import React, { useEffect, useState } from 'react';
import {
  GROUPBY_UNITS,
  MAX_GROUPBY_COUNT
} from '@nile/reports/src/modules/charts/constants';
import { getTranslatedText, Icon } from '@nile/components';
import Select from 'react-select';
import { cloneDeep } from 'lodash';
import { Times } from '@styled-icons/fa-solid';
import { Button } from '@superops/ui-design-system';
import {
  reactSelectErrorStyles,
  reactSelectInlineError
} from '@nile/banyan/src/Utils/style';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/banyan/src/Pebbles/select';
import { SVGIcon } from '@superops/super-icons';

function GroupByItem(props) {
  const {
    data,
    index,
    groupByAttributes = [],
    validateChartForm,
    context,
    intl,
    errors,
    groupedEntities,
    metaLoading = false
  } = props;

  const [selectedGroupBy, setSelectedGroupBy] = useState(null);

  const [selectedUnit, setSelectedUnit] = useState(null);

  const GroupByUnits = GROUPBY_UNITS.map((attr) => ({
    ...attr,
    label: getTranslatedText(intl, attr?.label)
  }));

  const selectGroupByHandler = (val) => {
    setSelectedGroupBy(val);
    const updatedGroupBy = cloneDeep(context?.value?.groupBy);
    if (val?.dataType === 'datetime' || val?.dataType === 'date') {
      updatedGroupBy[index] = {
        ...updatedGroupBy[index],
        attribute: val.name,
        unit: null
      };
    } else {
      updatedGroupBy[index] = {
        attribute: val.name
      };
    }
    context.updateContext({ ...context?.value, groupBy: updatedGroupBy });
  };

  const selectUnitHandler = (val) => {
    setSelectedUnit(val);
    const updatedGroupBy = cloneDeep(context?.value?.groupBy);
    updatedGroupBy[index] = { ...updatedGroupBy[index], unit: val.value };
    context.updateContext({ ...context?.value, groupBy: updatedGroupBy });
  };

  const deleteGroupByHandler = async () => {
    const currentGroupBy = cloneDeep(context?.value?.groupBy);
    const updatedGroupBy = currentGroupBy.filter((grp, ind) => ind !== index);
    await context.updateContext({
      ...context?.value,
      groupBy: updatedGroupBy?.length === 0 ? null : updatedGroupBy
    });
    if (validateChartForm) validateChartForm();
  };

  useEffect(() => {
    if (!metaLoading && groupByAttributes.length > 0) {
      setSelectedGroupBy(
        groupByAttributes.find((attr) => attr?.name === data?.attribute) || null
      );
      setSelectedUnit(
        GROUPBY_UNITS.find((attr) => data?.unit === attr.value) || null
      );
    }
  }, [metaLoading, groupByAttributes]);

  return (
    <div className="flex fx-sb mb-20 visibilityContainer">
      <div className="flex f11 g10">
        <div className="w50" superid="groupByselect">
          <Select
            value={selectedGroupBy}
            label={getTranslatedText(
              intl,
              'reports.chart.config.groupBy.label'
            )}
            isLoading={metaLoading}
            isDisabled={metaLoading}
            captureMenuScroll
            options={
              selectedGroupBy?.length >= MAX_GROUPBY_COUNT
                ? null
                : groupedEntities
            }
            onChange={selectGroupByHandler}
            components={{ IndicatorSeparator, DropdownIndicator }}
            classNamePrefix="value_selector"
            formatGroupLabel={formatGroupLabel}
            menuPlacement="auto"
            menuPortalTarget={document.body}
            placeholder={getTranslatedText(
              intl,
              'reports.chart.config.groupBy.placeholder'
            )}
            closeMenuOnScroll={(e) => {
              return (
                e.target &&
                e.target.classList &&
                !(e.target.classList.value.indexOf('menu-list') > -1)
              );
            }}
            styles={
              errors?.attribute
                ? {
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999999
                    }),
                    ...reactSelectErrorStyles
                  }
                : {
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999999
                    })
                  }
            }
            menuPortalTarget={document.body}
          />
          {errors?.attribute && reactSelectInlineError(errors?.attribute?.[0])}
        </div>

        {(selectedGroupBy?.dataType === 'datetime' ||
          selectedGroupBy?.dataType === 'date') && (
          <div className="w50 mr-10" superid="grpByTimeSelect">
            <Select
              value={
                selectedUnit &&
                GroupByUnits.find((el) => el.value === selectedUnit.value)
              }
              label={getTranslatedText(
                intl,
                'reports.chart.config.groupBy.unit.label'
              )}
              isLoading={metaLoading}
              menuPortalTarget={document.body}
              isDisabled={metaLoading}
              options={GroupByUnits}
              onChange={selectUnitHandler}
              components={{ IndicatorSeparator, DropdownIndicator }}
              classNamePrefix="value_selector"
              formatGroupLabel={formatGroupLabel}
              menuPlacement="auto"
              menuPortalTarget={document.body}
              placeholder={getTranslatedText(
                intl,
                'reports.chart.config.groupBy.unit.placeholder'
              )}
              closeMenuOnScroll={(e) => {
                return (
                  e.target &&
                  e.target.classList &&
                  !(e.target.classList.value.indexOf('menu-list') > -1)
                );
              }}
              styles={
                errors?.unit
                  ? {
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999
                      }),
                      ...reactSelectErrorStyles
                    }
                  : {
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999
                      })
                    }
              }
            />
            {errors?.unit && reactSelectInlineError(errors?.unit?.[0])}
          </div>
        )}
      </div>
      <div className="visibilityActions" superid="deleteGrpBy">
        <Button
          onClick={deleteGroupByHandler}
          icon={<SVGIcon name="Close" size="sm" />}
        />
      </div>
    </div>
  );
}

export default GroupByItem;
